<template>
  <div class="page-container">
    <van-nav-bar
      class="nav-bg"
      fixed
      :left-arrow="true"
      :z-index="10"
      @click-left="goableBack()">
      <template #title>
        <div class="nav-title-bg">
          <van-search
            class="search-bg"
            v-model="searchKey"
            :clearable="false"
            type="digit"
            maxlength="11"
            placeholder="请输入邀请人手机号/账户ID"
            background="#fff"
            @input="onInput"
            @search="onSearch"
            @cancel="onCancel">
            <template #right-icon>
              <van-icon name="cross" @click="onCancel" />
            </template>
          </van-search>
          <div class="search" @click="onSearch">搜索</div>
        </div>
      </template>
    </van-nav-bar>
    <div class="contain">
      <van-list :finished="true" finished-text="没有更多了">
        <div
          class="item-bg"
          v-for="(item, index) in dataSource"
          :key="index"
          @click="onClickItem(item)">
          <div class="avatar-bg">
            <img src="https://b.yzcdn.cn/vant/icon-demo-1126.png" />
            <!-- <van-image src=""></van-image> -->
          </div>
          <div class="right-bg">
            <div class="name">{{ item.name || "" }}</div>
            <div class="content">ID：{{ item.custId }}</div>
            <div class="content">手机号：{{ item.phone }}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { Icon, List, Search } from "vant"
import { getInviteCust } from "../../api/cust"
export default {
  name: "search_inviter",
  components: {
    [Search.name]: Search,
    [Icon.name]: Icon,
    [List.name]: List
  },
  data() {
    return {
      searchKey: "",
      disabled: false,
      dataSource: [],
      selectCustId: ""
    }
  },
  mounted() {},
  methods: {
    onInput(val) {
      // if (!this.disabled) {
      //   this.disabled = true
      //   setTimeout(() => {
      //     this.disabled = false
      //     this.loadList()
      //   }, 500)
      // }
    },
    loadList() {
      this._showLoading()
      getInviteCust(this.searchKey)
        .then((data) => {
          this._dismissLoading()
          this.dataSource = data
        })
        .catch((e) => {
          this._dismissLoading()
          this.$toast(e.msg || e.message)
        })
    },
    onSearch(val) {
      if (this.searchKey) {
        this.loadList()
      } else {
        this.onCancel()
      }
    },
    onCancel() {
      this.searchKey = ""
      this.dataSource = []
    },
    onClickItem(item) {
      this.selectCustId = item.custId || ""
      this.goableBack()
    }
  },
  beforeRouteLeave(to, from, next) {
    to.query.referrerCode = this.selectCustId
    next()
  }
}
</script>
<style lang="less" scoped>
.nav-bg {
  //   background-color: transparent;
  background-color: rgb(237, 242, 247);
  &::after {
    display: none;
  }
  ::v-deep .van-nav-bar__title {
    max-width: 100%;
    margin-left: 40px;
    border-radius: 5px;
    // width: calc(100% - 55px);
    width: 100%;
  }
  .nav-title-bg {
    display: flex;
    align-items: center;
    width: 100%;
    .search-bg {
      padding: 0;
      height: 34px;
      font-size: 12px;
      width: calc(100% - 55px);
      .van-search__conten,
      .van-search__content--square {
        background-color: white;
      }
    }
    .search {
      font-size: 15px;
      margin-left: 10px;
    }
  }
}
.contain {
  .item-bg {
    margin: 10px 15px 0px 15px;
    background-color: white;
    display: flex;
    align-items: center;
    border-radius: 8px;
    .avatar-bg {
      margin: 15px 10px;
      width: 50px;
      height: 50px;
      border-radius: 8px;
      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }
    .right-bg {
      .name {
        font-size: 14px;
        font-weight: 700;
      }
      .content {
        color: rgb(62, 111, 251);
      }
    }
  }
}
</style>